<template>
  <div class="panel panel-default">
    <div class="panel-heading">{{ caixaAlta(especialidade.nome) }}</div>
    <div class="panel-body panel_info">
      <table class="table table-striped table-hover tabela_info">
        <tbody>
          <tr>
            <td><strong>Convênios / Valor</strong></td>
            <td>
              <button
                data-test-id="button-exibiralertavalores-1"
                style="padding: 0; margin: 0"
                class="btn btn-xs btn-link"
                @click="
                  exibirAlertaValores(
                    'Convênios',
                    especialidade.convenios,
                    ['nome', '_valor'],
                    ['Nome', 'Valor']
                  )
                "
              >
                Ver todos
              </button>
            </td>
          </tr>
          <tr>
            <td><strong>Situação</strong></td>
            <td :class="especialidade.ativo ? 'text-success' : 'text-danger'">{{
              especialidade.ativo ? 'Ativo' : 'Cancelado'
            }}</td>
          </tr>
          <tr>
            <td><strong>Numeração Guia</strong></td>
            <td>{{
              especialidade.codigoNumeracaoGuia != null
                ? especialidade.codigoNumeracaoGuia
                : '-'
            }}</td>
          </tr>
        </tbody>
      </table>
      <div class="btn-group btn-group-justified" role="group">
        <RouterLink
          id="botaoEditar"
          data-test-id="link-botaoeditar"
          :to="'/especialidade/cadastro/' + especialidade._id"
          name="botaoEditar"
          role="button"
          class="btn btn-sm btn-default"
        >
          <span class="fa fa-edit" /> Editar
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<script>
import { alertaMixin } from '@/mixins/AlertaMixin'
import * as formatadores from '@/utils/formatadores'

export default {
  name: 'EspecialidadeFicha',
  mixins: [alertaMixin],
  props: {
    especialidade: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...formatadores,
  },
}
</script>
